import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IDmMucHocPhiTheoMonViewModelRequest } from "../../../model/request/category/dmMucHocPhiTheoMonViewModelRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { mucHocPhiTheoMonApi } from "./../../../api/category/mucHocPhiTheoMonApi";
import { IDmMucHocPhiTheoMon } from "./../../../model/respone/category/IDmMucHocPhiTheoMon";
import {
  eDmMucHocPhiTheoMonActionIds,
  IDmMucHocPhiTheoMonActionTypes,
} from "./../../action-types/category/IDmMucHocPhiTheoMonActions";
import { IDmMucHocPhiTheoMonCopyRequest } from "../../../model/request/category/dmMucHocPhiTheoMonCopyRequest";

export function* mucHocPhiTheoMonSaga(): any {
  yield takeLatest(eDmMucHocPhiTheoMonActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmMucHocPhiTheoMonActionIds.SAVE_START, saveWorker);
  yield takeLatest(eDmMucHocPhiTheoMonActionIds.LOCK_START, lockWorker);
  yield takeLatest(eDmMucHocPhiTheoMonActionIds.UNLOCK_START, unlockWorker);
  yield takeLatest(eDmMucHocPhiTheoMonActionIds.COPY_START, copyWorker);
}

function* loadWorker(action: IDmMucHocPhiTheoMonActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTheoMonViewModelRequest;
  // Chọn NHIỀU môn: load dữ liệu TỪNG môn rồi gộp (SP Select lọc theo 1 id_mon) → cây hiện đơn giá mỗi môn.
  const monList =
    payload.id_mons && payload.id_mons.length > 0
      ? payload.id_mons
      : payload.id_mon
        ? [payload.id_mon]
        : [];
  if (monList.length === 0) {
    yield put(rootActions.category.mucHocPhiTheoMon.LOAD_SUCCESS([]));
    return;
  }
  const merged: IDmMucHocPhiTheoMon[] = [];
  for (const id_mon of monList) {
    const res: IBaseRespone = yield call(mucHocPhiTheoMonApi.Select, {
      ...payload,
      id_mon,
    });
    if (!res.is_success) {
      yield put(
        rootActions.category.mucHocPhiTheoMon.LOAD_ERRR(res.message ?? "Có lỗi")
      );
      return;
    }
    merged.push(...((res.data as IDmMucHocPhiTheoMon[]) ?? []));
  }
  yield put(rootActions.category.mucHocPhiTheoMon.LOAD_SUCCESS(merged));
}

function* saveWorker(action: IDmMucHocPhiTheoMonActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTheoMon[];
  const res = yield call(mucHocPhiTheoMonApi.Save, payload);
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.mucHocPhiTheoMon.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.mucHocPhiTheoMon.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* lockWorker(action: IDmMucHocPhiTheoMonActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTheoMonViewModelRequest;
  const res = yield call(mucHocPhiTheoMonApi.Lock, payload);
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.mucHocPhiTheoMon.LOCK_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.mucHocPhiTheoMon.LOCK_ERRR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* unlockWorker(action: IDmMucHocPhiTheoMonActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTheoMonViewModelRequest;
  const res = yield call(mucHocPhiTheoMonApi.Unlock, payload);
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.mucHocPhiTheoMon.UNLOCK_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.mucHocPhiTheoMon.UNLOCK_ERRR(
          res.message ?? "Có lỗi"
        )
      );
    }
  }
}

function* copyWorker(action: IDmMucHocPhiTheoMonActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTheoMonCopyRequest;
  const res = yield call(mucHocPhiTheoMonApi.Copy, payload);
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.mucHocPhiTheoMon.COPY_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.mucHocPhiTheoMon.COPY_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}
